import { FC } from 'react';
import { FilterBlockItemBase, IFilterItemRendererProps } from '@cbridge-tools/filters-panel';
import { RulesManagementAction, rulesValidityFilterSelector } from '@cbridge-modules/rules-management-page';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { RuleValidity } from '@cbridge-tools/rules-data-grid';

export const ErrorInvalid: FC<IFilterItemRendererProps> = (props) => {
  const { item, depth } = props;
  const { value } = item;

  const dispatch = useDispatch();
  const validityFilter = useSelector(rulesValidityFilterSelector);

  const handleClick = () => {
    dispatch(RulesManagementAction.toggleValidityFilter(value as RuleValidity));
  };

  return (
    <FilterBlockItemBase
      item={item}
      depth={depth}
      isSelected={validityFilter[value]?.isActive}
      onClick={handleClick}
      count={validityFilter[value]?.count}
    />
  );
};
